import { render, staticRenderFns } from "./DeepseekRemoteDeploy.vue?vue&type=template&id=6832665a&scoped=true&"
import script from "./DeepseekRemoteDeploy.vue?vue&type=script&lang=js&"
export * from "./DeepseekRemoteDeploy.vue?vue&type=script&lang=js&"
import style0 from "./DeepseekRemoteDeploy.vue?vue&type=style&index=0&id=6832665a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6832665a",
  null
  
)

export default component.exports